 import React, { useState, useEffect } from 'react';
 

// Ejemplo de estilos en línea (puedes migrar a un .css o styled-components)
const styles = {
    container: {
        display: 'flex',
        minHeight: '100vh',
        fontFamily: 'sans-serif',
        overflow: 'hidden',
    },
    sidebarOld: {
        width: '260px',
        backgroundColor: '#f7f7f7',
        borderRight: '1px solid #ddd',
        padding: '20px',
        boxSizing: 'border-box'
    },
    sidebar: {
        width: '250px',
        backgroundColor: '#f5f5f5',
        padding: '1rem',
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        overflowY: 'auto',
        zIndex: 1,
        transition: 'transform 0.3s ease-in-out',
    },
    mainMobile: {
        marginLeft: 0,  // Sin espacio para el sidebar en móviles
    },
    sidebarTitle: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        marginBottom: '1rem'
    },
    sidebarNav: {
        listStyle: 'none',
        paddingLeft: 0
    },
    sidebarNavItem: {
        marginBottom: '.8rem'
    },
    mainOld: {
        flex: 1,
        padding: '40px',
        boxSizing: 'border-box'
    },
    main: {
        marginLeft: '250px', // espacio para el sidebar
        padding: '1rem',
        height: '100vh',
        overflowY: 'auto',
        flex: 1,
    },
    heading: {
        fontSize: '2rem',
        fontWeight: 'bold',
        marginBottom: '1rem'
    },
    subheading: {
        fontSize: '1.4rem',
        fontWeight: '600',
        marginTop: '2rem',
        marginBottom: '.5rem',
        color: 'black'
    },
    paragraph: {
        marginBottom: '1rem',
        /*  lineHeight: '1.5',*/
        color: 'black'
    },
    codeBlock: {
        backgroundColor: '#f4f4f4',
        /*padding: '1rem',*/
        padding: 5,
        borderRadius: '4px',
        fontFamily: 'monospace',
        marginBottom: '1rem',
        color: 'black'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '1rem'
    },
    thtd: {
        border: '1px solid #ccc',
        padding: '.5rem'
    },


    navList: {
        listStyle: "none",
        paddingLeft: 0,
        margin: 0
    },
    navItem: {
        marginBottom: ".6rem"
    },
    // Para las sub-listas anidadas
    subNav: {
        listStyle: "none",
        paddingLeft: "1.2rem",
        marginTop: ".3rem"
    },
    link: {
        color: "#333",
        textDecoration: "none"
    },
    descTitle: {
        color: "#333",
        textDecoration: "none",
        fontStyle: 'italic'
    }
};

export default function ApiReferencePage() {
    const [menuAbierto, setMenuAbierto] = useState(false);

    const toggleMenu = () => {
        setMenuAbierto(!menuAbierto);
    };

    /* useEffect(() => {
         // Verificamos si el ancla (hash) en la URL es #autoservicio
         if (window.location.hash === '#autoservicio') {
             // Desplazamos suavemente al elemento con el id autoservicio
             const autoservicioSection = document.getElementById('autoservicio');
             if (autoservicioSection) {
                 autoservicioSection.scrollIntoView({ behavior: 'smooth' });
             }
         }
     }, []);*/

    useEffect(() => {
        // Función para desplazarse al ID especificado en el hash de la URL
        const scrollToHash = () => {
            const hash = window.location.hash; // Obtener el hash de la URL
            if (hash) {
                const targetElement = document.getElementById(hash.substring(1)); // Obtener el elemento con el ID (eliminando el '#')
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth' }); // Desplazamiento suave
                }
            }
        };

        // Llamar a la función de desplazamiento cuando el componente se monta
        scrollToHash();

        // Si el hash cambia mientras la página está abierta (es decir, el usuario hace clic en un enlace),
        // volvemos a llamar a la función
        window.addEventListener('hashchange', scrollToHash);

        // Limpiar el listener al desmontar el componente
        return () => {
            window.removeEventListener('hashchange', scrollToHash);
        };
    }, []);

    return (
        <div style={styles.container}>
            <button
                onClick={toggleMenu}
                style={{
                    position: 'fixed',
                    top: 15,
                    left: 15,
                    zIndex: 1000,
                    backgroundColor: '#ffffff',
                    border: 'none',
                    width: '45px',
                    height: '45px',
                    borderRadius: '50%',
                    fontSize: '1.5rem',
                    cursor: 'pointer',
                    display: 'none',
                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 0,
                }}
                className="menu-btn"
            >
                ☰
            </button>


            {/* Sidebar (menú de secciones) */}
            <aside
                className={`sidebar ${menuAbierto ? 'menu-abierto' : ''}`}
                style={styles.sidebar}
            >
                <div style={styles.sidebarTitle} className='sidebarTitle'>API Reference</div>
                <ul style={styles.navList}>

                    {/* Sección: Introduction */}
                    <li style={styles.navItem}>
                        <a style={styles.link} href="#introduccion">Introduccion</a>
                    </li>


                    {/* Sección: Requests con sub-items */}
                    <li style={styles.navItem}>
                        <p style={styles.descTitle}>Tipos de Funcionamiento</p>
                        <ul style={styles.subNav}>
                            <li style={styles.navItem}>
                                <a style={styles.link} href="#codigo-venta">Codigo de Venta</a>
                                <ul style={styles.subNav}>

                                    <li style={styles.navItem}>
                                        <p style={styles.descTitle}>Tipos de Conexión</p>
                                        <ul style={styles.subNav}>
                                            <li style={styles.navItem}>
                                                <a style={styles.link} href="#webservice-conexion">Webservice</a>
                                            </li>
                                            <li style={styles.navItem}>
                                                <a style={styles.link} href="#websocket-conexion">Websocket</a>
                                            </li>

                                        </ul>
                                    </li>

                                    <li style={styles.navItem}>
                                        <a style={styles.link} href="#generar-codigo-venta">Generar Código de Pago</a>
                                    </li>
                                    <li style={styles.navItem}>
                                        <a style={styles.link} href="#termino-pago">Termino Pago</a>
                                    </li>
                                </ul>
                            </li>
                            <li style={styles.navItem}>
                                <a style={styles.link} href="#autoservicio">Autoservicio</a>
                                <ul style={styles.subNav}>
                                    <li style={styles.navItem}>
                                        <a style={styles.link} href="#cargar-venta">Cargar Venta</a>
                                    </li>
                                    <li style={styles.navItem}>
                                        <a style={styles.link} href="#cancelar-venta-cargada">Cancelar Venta Cargada</a>
                                    </li>
                                    <li style={styles.navItem}>
                                        <a style={styles.link} href="#respuesta-pago">Respuesta Pago</a>
                                    </li>
                                </ul>
                            </li>
                            <li style={styles.navItem}>
                                <a style={styles.link} href="#autocobro">Autocobro</a>
                            </li>
                        </ul>
                    </li>



                    {/* Sección:Endpoint Generales */}
                    <li style={styles.navItem}>
                        <a style={styles.link} href="#endpoints-generales">Endpoints Generales</a>
                        <ul style={styles.subNav}>
                            <li style={styles.navItem}>
                                <a style={styles.link} href="#status-venta">Status Venta</a>
                            </li>
                            <li style={styles.navItem}>
                                <a style={styles.link} href="#cancelar-venta">Cancelar Venta</a>
                            </li>
                            <li style={styles.navItem}>
                                <a style={styles.link} href="#codigo-devolucion">Codigo Devolución</a>
                            </li>
                        </ul>
                    </li>

                    {/* Sección: Objects con sub-items */}
                    <li style={styles.navItem}>
                        <a style={styles.link} href="#codigos-ejemplo">Codigos Ejemplo &amp; SDKs</a>
                        <ul style={styles.subNav}>
                            <li style={styles.navItem}>
                                <a style={styles.link} href="http://y.pc5r.com/file/download/kiosko/WS_C#.rar">C#</a>
                            </li>

                        </ul>
                    </li>


                    {/* Sección: Postam*/}
                    <li style={styles.navItem}>
                        <a style={styles.link} target='_blank' href="https://documenter.getpostman.com/view/6699576/2sAYdZst39">Postman Testing</a>
                    </li>

                </ul>
            </aside>


            {/* Contenedor principal (contenido) */}
            <main style={styles.main}>
                <h1 style={styles.heading} id='introduccion'>API Reference</h1>
                <p style={styles.paragraph}>
                    Esta documentación describe la API desarrollada para la integración y operación de cajeros automáticos (ATM) mediante servicios web (WebServices) y/o WebSockets, ofreciendo una solución flexible, escalable y adaptable a diferentes modalidades de uso.
                </p>

                <p>
                    Gracias a su arquitectura modular, esta API puede ser fácilmente integrada en distintos tipos de cajeros, terminales o soluciones físicas y virtuales, garantizando una comunicación segura, estable y en tiempo real con sistemas externos.
                    A lo largo de esta documentación encontrarás la descripción de los métodos disponibles, ejemplos de uso, esquemas de comunicación, flujos de interacción y las mejores prácticas para su implementación.
                </p>

                {/* == Aquí agregamos el bloque de la imagen (la solicitud y la respuesta) == */}
                {/* <div style={styles.codeBlock}>
                    <pre style={{ margin: 0 }}>
                        {`POST /api/team/ HTTP/1.1
Content-Type: application/json; charset=UTF-8
Host: localhost:8080
Content-Length: 26

{
  "name": "Spaceballs"
}`}
                    </pre>
                </div>*/}



                <hr />


                {/* <div id="introduction">
                    <h2 style={styles.subheading}>Introduction</h2>
                    <p style={styles.paragraph}>
                        You need an integration token to interact with the Notion API. If you lack an
                        integration token after creating an integration, we recommend beginning with the Getting
                        Started guide to learn how to create one.
                    </p>
                </div>**/}


                {/* Sección: Codigo-venta */}
                <div id="codigo-venta">
                    <h2 style={styles.subheading}>Código Venta</h2>
                    <p style={styles.paragraph}>
                        La modalidad de Codigo Venta funciona de la siguiente manera: El sistema integrador envia una petición al endpoint  <code style={styles.codeBlock}>/generarCodigoImagenPago</code> (<a href='#generar-codigo-venta' style={{ color: 'blue' }}>Ver Definición</a>) del servicio del cajero
                        y este regresa una respuesta exitosa o de error. Se podrá imprimir un codigo con el folio de la venta para que el cliente pase a escanear al Cajero y habilite su pago. Una vez realizado el pago, el cajero enviará un "termino pago" hasta el sistema integrador por medio del Tipo de Conexión elegido.
                    </p>

                </div>

                <div id="webservice-conexion">
                    <h2 style={styles.subheading}>Webservice</h2>
                    <p style={styles.paragraph}>
                        El Sistema integrador deberá exponer un Webhook POST para que el servicio del cajero envie los datos del "termino pago" cuando se pague una venta.
                        Esto permite la tener un endpoint para que el servicio del cajero envie la venta pagada al sistema integrador. Si el sistema no está habilitado y no puede recibir el objeto de la informacion del "termino pago" el servicio del cajero intentará cada 5 minutos enviar la venta hasta que el sistema integrador
                        regrese una respuesta de "RECIBIDO".
                    </p>

                </div>


                <div id="websocket-conexion">
                    <h2 style={styles.subheading}>Websocket</h2>
                    <p style={styles.paragraph}>
                        El Sistema integrador deberá establecer conexión con un websocket expuesto por el servicio del cajero.
                        Esto permite la comunicación persistente entre el sistema integrador con el servicio del cajero para recibir las ventas en cualquier momento.
                        Si el sistema está desconectado del websocket y no puede recibir el objeto de la informacion del "termino pago" el servicio del cajero intentará cada 5 minutos enviar la venta hasta que el sistema integrador
                        regrese una respuesta de "RECIBIDO".
                    </p>

                    <p>Ejemplo de conexión: <code style={styles.codeBlock}>wss://testqpmini.empatica.mx/ws?authorization=TOKEN</code></p>
                    <p>Despues de realizar la conexión exitosamente, se debe hacer un login con un usuario del sistema que se conectó. Esto para que el servicio del cajero pueda enviar los eventos al usuario correspondiente.</p>
                    <div style={styles.codeBlock}>
                        <pre style={{ margin: 0 }}>
                            {`{
  "clave": "nuevoUsuario",
  "usuario": "",
  "token":""
}
`
                            }
                        </pre>
                    </div>
                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Request</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Es un identificador de la acción. En este caso: "nuevoUsuario"</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>usuario</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Es un usuario único que el servicio usará para la comunicación websocket.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>token</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Es el token de autorización para la conexión. Este token es único para cada cliente.</td>
                            </tr>
                        </tbody>
                    </table>
                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Response</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Es un identificador de la acción.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>msg</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Número que identica si fue exitosa o no la acción. 200 Exitosa, 300 No exitosa.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>respuesta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Es un texto que describe la respuesta de la acción.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>



                <div id="generar-codigo-venta">
                    <h2 style={styles.subheading}>Generar Código de Venta</h2>
                    <p style={styles.paragraph}>
                        Para generar un codigo de venta, se envia una petición POST al endpoint <code style={styles.codeBlock}>/generarCodigoImagenPago</code> con la siguiente definición en el objeto data:
                    </p>
                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Request</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador del tipo de mensaje o acción. En este caso: "generarCodigoImagenPago".</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>usuario</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Es un usuario único que el servicio usará para la comunicación websocket.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>monto</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Monto redondeado del total de la venta. Formato máximo 2 decimales. Ejemplos válidos: 10.00, 1.00, 15</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>montoReal</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Monto sin redondear. Formato máximo 2 decimales. Ejemplos: 10.50, 2.35</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>tipoPago</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Método de pago con el que se va a cobrar. Valores permitidos: "EFECTIVO", "TARJETA", "" (pantalla de selección).</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>subtotal</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Sumatoria de los subtotales de los productos antes de incluir el IVA.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>IVA</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Sumatoria del valor de los IVA de los productos.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Folio del sistema que se conecta con el servicio del cajero. Sirve para identificar la venta.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>IdStatus</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Estado de la venta. Valores permitidos: 0 (PENDIENTE), 1 (PAGADA). Para el cajero debe ser 0.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>vendedor</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Nombre del vendedor. Se usa en el ticket impreso.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>onlyCode</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>0 Si se desea obtener los base64 de las imagenes de los codigos. 1 para no retornar los base64.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>TipoRecibo</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Tipo de ticket a imprimir. Valores: "COMPLETO", "INCOMPLETO".</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>noTickets</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Cantidad de tickets de pago a imprimir.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>fechaLimite</td>
                                <td style={styles.thtd}>String (YYYY-MM-DD)</td>
                                <td style={styles.thtd}>Fecha límite de validez de la venta. Por defecto es 1 día.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>token</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Token de autorización único por cliente para la conexión.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos</td>
                                <td style={styles.thtd}>Array&lt;Producto&gt;</td>
                                <td style={styles.thtd}>Lista de productos de la venta.</td>
                            </tr>

                            {/* Detalle de objeto producto */}
                            <tr>
                                <td style={styles.thtd}>datos[].cantidad</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Cantidad del producto. Ejemplos: 1, 3.002</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos[].producto</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Nombre del producto.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos[].monto</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Subtotal del producto con IVA. Formato máx. 2 decimales.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos[].subtotal</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Subtotal del producto antes del IVA. Máx. 2 decimales.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos[].IVA</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Valor del IVA calculado.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos[].IVA_Porcen</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Porcentaje del IVA aplicado.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos[].PrecioUnitarioVenta</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Precio unitario del producto. Máximo 2 decimales.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos[].UM</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Unidad de medida. Ejemplos: Pz, Kg.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos[].Categoria</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Nombre de la categoría del producto.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos[].SubCategoria</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Nombre de la subcategoría del producto.</td>
                            </tr>
                        </tbody>
                    </table>


                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Response</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>msg</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Número que indica el resultado. 200 Exitosa, 300 No exitosa.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>respuesta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Texto descriptivo del resultado de la acción.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>qrcodeImagen</td>
                                <td style={styles.thtd}>String (base64)</td>
                                <td style={styles.thtd}>Imagen en formato base64 del código QR generado. Si onlyCode es = 0</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>barcodeImagen</td>
                                <td style={styles.thtd}>String (base64)</td>
                                <td style={styles.thtd}>Imagen en formato base64 del código de barras generado.  Si onlyCode es = 0</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>codigo</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Código alfanumérico generado para representar la venta.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Folio del sistema que identifica la venta.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>clienteFila</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Nombre o identificador del cliente o venta en pantalla (ej. "Venta 271").</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>empresa</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Nombre de la empresa que emite el ticket o realiza la operación.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>infoExtra</td>
                                <td style={styles.thtd}>String / null</td>
                                <td style={styles.thtd}>Campo opcional para información adicional. Puede ser null.</td>
                            </tr>
                        </tbody>
                    </table>

                </div>



                <div id="termino-pago">
                    <h2 style={styles.subheading}>Termino Pago</h2>
                    <p style={styles.paragraph}>
                        Una vez realizada una venta en el cajero, se enviará la información al sistema integrador.
                    </p>

                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Request</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador del tipo de mensaje o acción. En este caso: "terminoPago".</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>usuario</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Usuario que realizó la operación.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Folio único que identifica la venta realizada.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>monto</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Monto total de la venta (ya redondeado). Máximo 2 decimales.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>ingresado</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Cantidad de dinero ingresada por el cliente.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>cambioDispensado</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Cambio devuelto al cliente (si aplica).</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>tipoPago</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Forma de pago utilizada. Ejemplo: "EFECTIVO", "TARJETA".</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>status</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Código de estado de la transacción. Ej: 1 = Pagado</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>statusTexto</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Descripción textual del estado de la venta. Ej: "Venta pagada correctamente".</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>claveCajero</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Clave o identificador del cajero que procesó la venta.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>fechaHora</td>
                                <td style={styles.thtd}>String (ISO 8601)</td>
                                <td style={styles.thtd}>Fecha y hora en la que se realizó el pago. Ej: "2025-04-16T14:35:22".</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>claveTransaccion</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador único de la transacción generada por el cajero.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>noCajero</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Número del cajero físico o lógico que atendió la transacción.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>montoReal</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Monto total de la venta sin redondear (real). Máximo 2 decimales.</td>
                            </tr>
                        </tbody>
                    </table>

                </div>


                <div id="autoservicio">
                    <h2 style={styles.subheading}>Autoservicio</h2>
                    <p style={styles.paragraph}>
                        En esta modalidad es para integrar una pantalla directo al cajero mediante su ip de red local. De esta forma el cliente podrá seleccionar sus productos en la pantalla,
                        enviar directo el cobro al cajero y esperar el pago. La conexión es por medio de un websocket que expone el cajero en un puerto en especifico.
                    </p>
                    <p>Ejemplo de conexión: <code style={styles.codeBlock}>ws://192.168.0.1:7075?authorization=TOKEN</code></p>
                    <p>Despues de realizar la conexión exitosamente, se debe hacer un registro de la pantalla enviando:</p>
                    <div style={styles.codeBlock}>
                        <pre style={{ margin: 0 }}>
                            {`{
  "clave": "nuevaPantalla",
  "token":""
}
`
                            }
                        </pre>
                    </div>
                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Request</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Es un identificador de la acción.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>token</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Es el token de autorización para la conexión. Este token es único para cada cliente.</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Response</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                                <th style={styles.thtd}>Aplica</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Indica el estado del flujo. Valores: "sinProceso", "esperandoPago", "esperandoSeleccionTipoPago".</td>
                                <td style={styles.thtd}>Todos</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador de la venta en curso.</td>
                                <td style={styles.thtd}>esperandoPago, esperandoSeleccionTipoPago</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>monto</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Monto total de la venta.</td>
                                <td style={styles.thtd}>esperandoPago, esperandoSeleccionTipoPago</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datos</td>
                                <td style={styles.thtd}>Array</td>
                                <td style={styles.thtd}>Listado de productos asociados a la venta.</td>
                                <td style={styles.thtd}>esperandoPago, esperandoSeleccionTipoPago</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>tipoPago</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Método de pago elegido. Ej: "EFECTIVO", "TARJETA".</td>
                                <td style={styles.thtd}>esperandoPago</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }} id='cargar-venta'>Cargar Venta</h3>
                    <p>Despues de realizar la conexión al cajero exitosamente, para enviar un pago directo al cajero se realiza de la siguiente manera:</p>
                    <div style={styles.codeBlock}>
                        <pre style={{ margin: 0 }}>
                            {`{
  "clave": "cargarVenta",
  "venta": {OBJETO_VENTA},
  "token":""
}
`
                            }
                        </pre>
                    </div>
                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Request</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador de la acción enviada. En este caso: "cargarVenta".</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>venta</td>
                                <td style={styles.thtd}>Object</td>
                                <td style={styles.thtd}>Objeto con todos los datos de la venta. Contiene la información completa de productos, montos, forma de pago, etc. <a href='#generar-codigo-venta' style={{ color: 'blue' }}>Ver Definición</a></td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>token</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Token de autorización o seguridad para validar la carga de la venta.</td>
                            </tr>
                        </tbody>
                    </table>


                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Response</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                                <th style={styles.thtd}>Condición</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador de la acción de respuesta. Siempre será "respuestaCargarVenta".</td>
                                <td style={styles.thtd}>Siempre</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>msg</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Código de estado de la operación.<br />Valores:<br /><strong>"200"</strong>: Éxito<br /><strong>"300"</strong>: Error</td>
                                <td style={styles.thtd}>Siempre</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>respuesta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Mensaje descriptivo del resultado.</td>
                                <td style={styles.thtd}>
                                    Según el flujo:<br />
                                    - "Venta generada correctamente."<br />
                                    - "No se pudo generar la venta."<br />
                                    - "Token inválido."<br />
                                    - "No se pudo generar la venta. Cajero ocupado."
                                </td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Folio asignado a la venta generada.</td>
                                <td style={styles.thtd}>Solo si <strong>msg = "200"</strong> (venta exitosa)</td>
                            </tr>
                        </tbody>
                    </table>

                    <br />
                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }} id='cancelar-venta-cargada'>Cancelar Venta Cargada</h3>
                    <p>Para cancelar un pago cargado se realiza con la siguiente definición:</p>
                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Request</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                                <th style={styles.thtd}>Condición</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Indica la acción a realizar. En este caso, "cancelarPago".</td>
                                <td style={styles.thtd}>Solo si el pago fue cargado con tipoPago = EFECTIVO</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>token</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Token de autenticación que valida la solicitud del cliente.</td>
                                <td style={styles.thtd}></td>
                            </tr>
                        </tbody>
                    </table>

                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }} id='respuesta-pago'>Respuesta Pago</h3>
                    <p>La respuesta final del pago cargado:</p>
                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Response</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                                <th style={styles.thtd}>Valores posibles</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador del tipo de mensaje enviado. En este caso: "pagoRespuesta".</td>
                                <td style={styles.thtd}>"pagoRespuesta"</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Folio único que identifica la venta relacionada con el pago.</td>
                                <td style={styles.thtd}>El folio de la venta cargada.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>monto</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Monto total de la venta asociada al pago.</td>
                                <td style={styles.thtd}>Formato con máximo 2 decimales</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>status</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Estado del pago.</td>
                                <td style={styles.thtd}>
                                    <strong>0</strong>: Pago cancelado<br />
                                    <strong>1</strong>: Pago exitoso
                                </td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>datosTarjeta</td>
                                <td style={styles.thtd}>Object</td>
                                <td style={styles.thtd}>Es un objeto con los datos de la tarjeta con la que se pagó.</td>
                                <td style={styles.thtd}>Objeto, solo si el pago fue con TARJETA</td>
                            </tr>

                        </tbody>
                    </table>

                </div>


                <div id="autocobro">
                    <h2 style={styles.subheading}>Autocobro</h2>
                    <p style={styles.paragraph}>
                        En construcción...
                    </p>

                </div>



                {/* Sección: endpoints-generales */}
                <div id="endpoints-generales">
                    <h2 style={styles.subheading}>Endpoints Generales</h2>
                    <p style={styles.paragraph}>
                        Definición de endpoints generales del servicio del cajero.
                    </p>
                    {/* <div style={styles.codeBlock}>
                        <pre>
                            {`GET /databases/:database_id
Authorization: Bearer <token>`}
                        </pre>
                    </div>*/}


                </div>


                <div id="status-venta">
                    <h2 style={styles.subheading}>Status Venta</h2>
                    <p style={styles.paragraph}>
                        Para obtener la información de un folio en especifico.
                    </p>

                    <div style={styles.codeBlock}>
                        <pre>
                            {`POST /getStatusVenta`}
                        </pre>
                    </div>

                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Request</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Folio único de la venta, utilizado para identificar la transacción en el sistema.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>token</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Token cifrado de autenticación necesario para validar la operación o acceso.</td>
                            </tr>
                        </tbody>
                    </table>


                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Response</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>msg</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Código de estado. "200" indica que la respuesta es exitosa.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>respuesta</td>
                                <td style={styles.thtd}>Object</td>
                                <td style={styles.thtd}>Objeto que contiene la información detallada de la venta procesada.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>Empresa</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Nombre de la empresa que generó la venta.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>Sucursal</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Nombre de la sucursal donde se realizó la venta.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>VentaID_Externa</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Folio de la venta en el sistema externo.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>ClaveTransaccion</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador único de la transacción.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>IdStatus</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Estado de la venta:<br /><strong>1</strong>: Pagada,<br /><strong>0</strong>: Pendiente</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>TipoPago</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Método de pago utilizado. Ej: "EFECTIVO", "TARJETA"</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>Productos</td>
                                <td style={styles.thtd}>String (JSON)</td>
                                <td style={styles.thtd}>Lista de productos vendidos en formato JSON serializado.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>TotalVenta</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Monto total de la venta.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>recibido</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Monto recibido del cliente para el pago.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>cambio</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Cambio entregado al cliente.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>abono</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>Monto abonado (si aplica, para pagos parciales).</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>vendedor</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Nombre del vendedor que realizó la operación.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>fechaLimite</td>
                                <td style={styles.thtd}>String (YYYY-MM-DD HH:mm:ss)</td>
                                <td style={styles.thtd}>Fecha y hora límite de validez de la venta.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>IdCajero</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador único del cajero que procesó la venta.</td>
                            </tr>
                        </tbody>
                    </table>

                </div>


                <div id="cancelar-venta">
                    <h2 style={styles.subheading}>Cancelar Venta</h2>
                    <p style={styles.paragraph}>
                        Para cancelar un folio en especifico.
                    </p>

                    <div style={styles.codeBlock}>
                        <pre>
                            {`POST /cancelarVenta`}
                        </pre>
                    </div>


                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Request</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador único de la venta generada previamente en el sistema.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>usuario</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Nombre o identificador del usuario que realiza la operación.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>token</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Token de autenticación cifrado, necesario para validar la solicitud.</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Response</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador del tipo de mensaje. En este caso, indica que es una respuesta de cancelación.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>msg</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Código de estado de la operación. "200" indica éxito, "300" indica error.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>respuesta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Mensaje descriptivo del resultado de la cancelación.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Folio único de la venta que fue cancelada.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>claveTransaccion</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador único de la transacción relacionada a la venta cancelada.</td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <div id="codigo-devolucion">
                    <h2 style={styles.subheading}>Codigo Devolución</h2>
                    <p style={styles.paragraph}>
                        Para generar un código de devolución.
                    </p>

                    <div style={styles.codeBlock}>
                        <pre>
                            {`POST /generarCodigoImagenDevolucion`}
                        </pre>
                    </div>

                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Request</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Folio único de la venta a la que se hará referencia o sobre la cual se realiza la acción.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>token</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Token de autenticación cifrado que valida la autorización del cliente o sistema que realiza la solicitud.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>onlyCode</td>
                                <td style={styles.thtd}>Number</td>
                                <td style={styles.thtd}>0 Si se desea obtener los base64 de las imagenes de los codigos. 1 para no retornar los base64.</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3 style={{ ...styles.subheading, marginTop: '0.5rem' }}>Response</h3>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.thtd}>Parámetro</th>
                                <th style={styles.thtd}>Tipo</th>
                                <th style={styles.thtd}>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={styles.thtd}>clave</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Identificador del tipo de mensaje. En este caso: "codigoImagenDevolucion"</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>msg</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Código de estado de la operación. "200" indica éxito, "300" indica error.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>respuesta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Mensaje descriptivo del resultado de la operación.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>qrcodeImagen</td>
                                <td style={styles.thtd}>String (base64)</td>
                                <td style={styles.thtd}>Código QR generado en base64, asociado a la devolución. Se usa para escanear o mostrar visualmente.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>barcodeImagen</td>
                                <td style={styles.thtd}>String (base64)</td>
                                <td style={styles.thtd}>Código de barras en base64 correspondiente a la devolución.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>codigo</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Código alfanumérico generado que identifica de forma única la solicitud de devolución.</td>
                            </tr>
                            <tr>
                                <td style={styles.thtd}>folioVenta</td>
                                <td style={styles.thtd}>String</td>
                                <td style={styles.thtd}>Folio único de la venta que está asociada al código de devolución generado.</td>
                            </tr>
                        </tbody>
                    </table>


                </div>


            </main>
        </div>
    );
}
